(() => {
  const prepareVideo = (video) => {
    if (video.dataset.stAutoplayReady === 'true') return;
    video.dataset.stAutoplayReady = 'true';

    video.autoplay = true;
    video.defaultMuted = true;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;
    video.setAttribute('autoplay', '');
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');

    const play = () => video.play().catch(() => {});
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) play();
        else video.pause();
      },
      { threshold: 0.05 }
    );

    observer.observe(video);
    video.addEventListener('loadedmetadata', play, { once: true });
    video.addEventListener('pause', () => {
      if (video.getBoundingClientRect().bottom > 0 && video.getBoundingClientRect().top < window.innerHeight) play();
    });
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-st-optimized-video]').forEach(prepareVideo);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      document.querySelectorAll('[data-st-optimized-video]').forEach((video) => {
        const rect = video.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) video.play().catch(() => {});
      });
    }
  });
})();
